import { FC } from 'react';
import { MembersEmpty } from '@images';

import { Button, EmptyScreen, Icon } from '@components/index';
import UserPermissionTypes from '@constants/permissions';
import testId from '@constants/testId';
import useCheckPermission from '@hooks/checkPermission';

interface MemberEmptyScreenProps {
  hasSearch: boolean;
  handleAddMember?: () => void;
  handleUploadCSV?: () => void;
  handleCustomiseFields?: () => void;
  showCustomiseFieldsButton?: boolean;
  isFinanceAdmin?: boolean;
}

const MemberEmptyScreen: FC<MemberEmptyScreenProps> = ({
  handleAddMember,
  hasSearch,
  handleUploadCSV,
  handleCustomiseFields,
  showCustomiseFieldsButton = true,
  isFinanceAdmin = false
}) => {
  const { checkPermission } = useCheckPermission();
  const hasBranchMemberCreateAccess = checkPermission([
    UserPermissionTypes.BRANCH_MEMBER_CREATE
  ]);

  if (hasSearch) return <EmptyScreen />;

  return (
    <div className="flex size-full flex-col items-center justify-center">
      <MembersEmpty />
      <div className="mt-4 text-xl font-medium text-[#1f1f1f]">
        No members added yet
      </div>
      {!isFinanceAdmin && (
        <div className="mt-1 text-sm font-normal text-[#444444]">
          Add members to see them here
        </div>
      )}
      {!isFinanceAdmin && (
        <div className="mt-6 flex gap-4">
          {handleAddMember && (
            <>
              <Button
                id={testId.members.memberList.emptyScreenAddMemberButton}
                label="Add member"
                handleClick={handleAddMember}
                variant="primary"
                size="large"
                leftIconName="add-plus"
                disabled={!hasBranchMemberCreateAccess}
                labelStyle="!font-medium"
              />
              <Button
                id={testId.members.memberList.uploadCSVFile}
                label="Bulk Upload"
                handleClick={handleUploadCSV}
                variant="secondary"
                size="medium"
                leftIconName="bulk-upload"
                labelStyle="!font-medium"
                disabled={!hasBranchMemberCreateAccess}
              />
            </>
          )}
        </div>
      )}
      {!isFinanceAdmin && showCustomiseFieldsButton && (
        <div className="flex items-center gap-1">
          <Icon name="info-circle" size="16" />
          <div className="text-sm font-normal text-cofeeNeutral7">
            Need custom fields for members? You can customize them
          </div>
          <Button
            label="here."
            className="!p-0"
            variant="transparent"
            labelStyle="text-cofeePrimary6 underline"
            handleClick={handleCustomiseFields}
          />
        </div>
      )}
    </div>
  );
};

export default MemberEmptyScreen;
